import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import BaseMarketingController from "./BaseMarketingController";
import { darkTheme } from "../../config/themes";

import { ForceDarkTheme } from "../components/voxcraft/_shared";
import NtVoxcraftHero from "../components/voxcraft/NtVoxcraftHero";
import NtVoxcraftTrustMarquee from "../components/voxcraft/NtVoxcraftTrustMarquee";
import NtVoxcraftFeatures from "../components/voxcraft/NtVoxcraftFeatures";
import NtVoxcraftSiplense from "../components/voxcraft/NtVoxcraftSiplense";
import NtVoxcraftAiSection from "../components/voxcraft/NtVoxcraftAiSection";
import NtVoxcraftIndustries from "../components/voxcraft/NtVoxcraftIndustries";
import NtVoxcraftMaritimeDeepDive from "../components/voxcraft/NtVoxcraftMaritimeDeepDive";
import NtVoxcraftImpactStudies from "../components/voxcraft/NtVoxcraftImpactStudies";
import NtVoxcraftSecurity from "../components/voxcraft/NtVoxcraftSecurity";
import NtVoxcraftPricing from "../components/voxcraft/NtVoxcraftPricing";
import NtVoxcraftCtaStrip from "../components/voxcraft/NtVoxcraftCtaStrip";

class MarketingController extends BaseMarketingController {
  state = {};

  componentDidMount() {
    super.componentDidMount && super.componentDidMount();
    if (typeof document !== "undefined") {
      document.title = "Voxcraft | Multi-tenant PBX";
    }
  }

  render() {
    return (
      <ForceDarkTheme>
        <View style={[styles.surface, { backgroundColor: darkTheme.bg }]}>
          <NtMarketingPageContainer>
            <NtVoxcraftHero />
            <NtVoxcraftTrustMarquee />
            <NtVoxcraftFeatures />
            <NtVoxcraftSiplense />
            <NtVoxcraftAiSection />
            <NtVoxcraftIndustries />
            <NtVoxcraftMaritimeDeepDive />
            <NtVoxcraftImpactStudies />
            <NtVoxcraftSecurity />
            <NtVoxcraftPricing />
            <NtVoxcraftCtaStrip />
          </NtMarketingPageContainer>
        </View>
      </ForceDarkTheme>
    );
  }
}

const styles = StyleSheet.create({
  surface: { width: "100%", minHeight: "100%" },
});

export default MarketingController;
